import { render, staticRenderFns } from "./DeviceParameter.vue?vue&type=template&id=427778b6&scoped=true&"
import script from "./DeviceParameter.vue?vue&type=script&lang=js&"
export * from "./DeviceParameter.vue?vue&type=script&lang=js&"
import style0 from "./DeviceParameter.vue?vue&type=style&index=0&id=427778b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427778b6",
  null
  
)

export default component.exports